export default [
  {
    slug: "why-is-canada-warming-faster-than-the-world",
    title: `Why Is Canada Warming Faster Than the World As a Whole?`,
    img: "lassen-why-is-canada-warming-faster.jpg",
    audio:
      "/lassen/audio/why_is_canada_warming_faster_than_the_world_as_a_whole.mp3",
    fg: "#ffe5cf",
    bg: "#b77162",
    shadow: "#c3b286",
    blend: "#b77162",
    mode: "normal",
    links: [
      {
        title: "Future climate change and climate forcing",
        author: "",
        publication: "Canada’s Changing Climate Report",
        url: "https://changingclimate.ca/CCCR2019/chapter/3-0/3-2",
      },
      {
        title: "Rates of warming for Canada, the Canadian Arctic and the world",
        author: "",
        publication: "Canada’s Changing Climate Report",
        url: "https://changingclimate.ca/CCCR2019/chapter/3-0/3-2/figure-3-3/",
      },
      {
        title:
          "Contributions to warming of various feedback mechanisms for the Arctic and the Tropics",
        author: "",
        publication: "Canada’s Changing Climate Report",
        url: "https://changingclimate.ca/CCCR2019/chapter/3-0/3-2/figure-3-4/ ",
      },
      {
        title: "Comparative resolution of global and regional climate models",
        author: "",
        publication: "Canada’s Changing Climate Report",
        url: "https://changingclimate.ca/CCCR2019/chapter/3-0/3-2/figure-3-10/",
      },
    ],

    transcript: `<p> The annual average temperature in Canada increased by 1.7°C between 1948 and 2016, roughly twice the increase observed for the Earth as a whole.
</p>

<p> The response of the climate system to increasing greenhouse gases varies from one region to another.As a result, the rates of warming around the world are not the same.These variations are a result of climate pro - cesses and feedbacks that depend on local conditions.For example, in Canada, loss of snow and sea ice is reducing the reflectivity(or albedo, see Chapter 2, Box 2.3) of the surface, which is increasing the absorption of solar radiation.This causes larger surface warming than in more southerly regions.Because of this and other mechanisms, Canada is warming faster than the world as a whole— at more than twice the global rate— and the Canadian Arctic is warming even faster— at about three times the global rate.
</p>

<p> Enhanced warming for the Canadian Arctic in particular is part of a climate phenomenon known as“ Arctic amplification.”In all regions of the world, the climate response to radiative forcing from greenhouse gases is determined by subsequent processes and feedbacks within the climate system.The enhanced warming over high - northern latitudes is due to contributions from five well - known climate feedbacks.These are, in decreasing order of importance, lapse - rate feedback, snow / ice albedo feedback, Planck feedback, cloud feedback, and water vapour feedback.In the Arctic, each of these is a positive(amplifying) feedback— these feedbacks enhance the warming from greenhouse gas forcing.These feedbacks operate elsewhere as well, but their strength and direction vary from one region to another, and most are stronger in the Arctic.
</p>

<p> In summary, warming caused by increasing greenhouse gas concentrations varies from place to place, largely due to differing feedbacks at play from one region of the world to the next.Enhanced rates of warming over Canada and the Canadian Arctic are due to a unique combination of such feedback mechanisms.
</p>

<p> Hi everyone, this is Małgorzata Stankiewicz here and you just heard me quote from the Canada’ s Changing Climate Report as part of my public space installation, Lassen(This Is an Emergency), which explores urgent topics affecting Canada in the wake of the deepening climate crisis while questioning the impact and role of mass - media in portraying and shaping the discourse around the global environmental emergency.The works are displayed on large - scale posters throughout the streets of Toronto during Contact Photography Festival in June 2021.
</p>`,
  },
  {
    slug: "violence-against-the-earth-begets-violence-against-women",
    title: `Violence Against The Earth Begets Violence Against Women and all marginalised and gender non conforming people`,
    audio:
      "/lassen/audio/violence-against-the-earth-begets-violence-against-women.mp3",
    img: "lassen-violence-against-the-earth.jpg",
    bg: "#231b28",
    fg: "#dbc8cf",
    shadow: "#1d1a23",
    blend: "#ac3b35",
    mode: "normal",
    links: [
      {
        title: "Climate justice must include gender justice",
        author:
          "Melina Laboucan-Massimo, Indigenous Knowledge and Climate Change Fellow",
        publication: "David Suzuki Foundation",
        url: "https://davidsuzuki.org/story/climate-justice-must-include-gender-justice/",
      },
      {
        title: "Staying Alive. Women, Ecology and Development",
        author: "Vandana Shiva",
        publication: "",
        url: "https://www.penguinrandomhouse.com/books/537607/staying-alive-by-vandana-shiva/",
      },
      {
        title: "Feminism and Ecology: On the Domination of Nature",
        author: "Patricia Jagentowicz Mills",
        publication: "",
        url: "https://www.jstor.org/stable/3810039?read-now=1&seq=1#",
      },
      {
        title:
          "Yukon First Nations leaders fear mine will increase violence against women in ‘land of the caribou’",
        author: "Julien Gignac",
        publication: "The Narwhal",
        url: "https://thenarwhal.ca/yukon-first-nations-leaders-fear-mine-increase-violence-against-women-land-caribou/",
      },
      {
        title:
          "B.C. failed to consider links between ‘man camps,’ violence against Indigenous women, Wet’suwet’en argue",
        author: "Carol Linnit",
        publication: "The Narwhal",
        url: "https://thenarwhal.ca/b-c-failed-to-consider-links-between-man-camps-violence-against-indigenous-women-wetsuweten-argue/",
      },
      {
        title: "Environmental degradation driving gender-based violence",
        author: "",
        publication: "IUCN, International Union for Conservation of Nature",
        url: "https://www.iucn.org/news/gender/202001/environmental-degradation-driving-gender-based-violence-iucn-study",
      },
      {
        title: "Climate breakdown 'is increasing violence against women'",
        author: "Fiona Harvey",
        publication: "The Guardian",
        url: "https://www.theguardian.com/environment/2020/jan/29/climate-breakdown-is-increasing-violence-against-women",
      },
    ],
    transcript:
      "<p>There is a direct link between natural resource extraction and violence against largely Indigenous women and girls,</p> <p> Along with pipelines and the extractive economic engines they support— like Alberta’ s oilsands— come so - called“ man camps.”Located near extraction sites, these are where mostly male workers live in close quarters for weeks or months at a time. </p> <p> Most are outsiders to the region, lured in by the prospect of making a lot of money in a short time.Many must leave their families and communities to find work in the oilsands, when their preference would be to stay put, due to economic downturns at home.They seldom have ties to neighbouring First Nations communities.It’ s not surprising that some workers turn to drugs, alcohol and sex to blow off steam during days off.Studies show that demand for sex work accompanies intensive resource development due to the high number of male workers with excess income.This creates a dangerous mix for women in nearby communities, as the transience of the mostly male workforce means few are held accountable for what they do inor near camp. </p> <p > Violence against Indigenous women has systemic causes that are colonial in nature, dating back to racist policies that included separating Indigenous children from their parents and forcibly placing them in residential schools. </p> <p > The interconnections between gendered relationships of domination among humans, and between humans, nonhumans, and the earth are inextricably bound to the oppression, domination, exploitation, and colonization perpetuated by the Western patriarchal society, which for centuries failed to perceive the interconnectedness of nature, or the connection of women 's lives, work and knowledge with the creation of wealth.</p> <p> Patriarchy is foregrounded by another hierarchy— human domination over“ nature” and the belief that the earth and its nonhuman inhabitants are ours to exploit. </p> <p> Hi everyone, this is Małgorzata Stankiewicz here and you just heard me quote from a piece by Melina Laboucan - Massimo, David Suzuki Foundation Indigenous Knowledge and Climate Change Fellow, and Staying alive: women, ecology and development by Vandana Shiva as part of my public space installation, Lassen(This Is an Emergency), which explores urgent topics affecting Canada in the wake of the deepening climate crisis while questioning the impact and role of mass - media in portraying and shaping the discourse around the global environmental emergency.The works are displayed on large - scale posters throughout the streets of Toronto during Contact Photography Festival in June 2021. </p>",
  },
  {
    slug: "climate-change-affects-people-differently",
    title: "Climate Change Affects People Differently",
    img: "lassen-climate-change-affects-people-differently.jpg",
    audio: "/lassen/audio/climate_change_affects_people_differently.mp3",
    bg: "#9c7f6d",
    fg: "#d6bd9d",
    shadow: "#29283b",
    blend: "#29283b",
    mode: "normal",
    links: [
      {
        title: "What is ‘climate justice’?",
        author: "Daisy Simmons",
        publication: "Yale Climate Connections",
        blurb: "",
        url: "https://yaleclimateconnections.org/2020/07/what-is-climate-justice/",
      },
      // {
      //     title: "",
      //     author: "City of Vancouver",
      //     publication: "City of Vancouver",
      //     blurb: "",
      //     url: "https://vancouver.ca/files/cov/climate-emergency-action-plan-summary-2020-2025.pdf",
      // },
      {
        title: "Climate Justice Alliances",
        blurb: "",
        url: "https://climatejusticealliance.org/",
      },
      {
        title: "Climate change is also a racial justice problem",
        author: "Sarah Kaplan",
        publication: "The Washington Post",
        blurb: "",
        url: "https://www.washingtonpost.com/climate-solutions/2020/06/29/climate-change-racism/",
      },
      {
        title: "CLIMATE CHANGE",
        publication: "Amnesty International",
        blurb: "",
        url: "https://www.amnesty.org/en/what-we-do/climate-change/",
      },
      {
        title: "Indigenous Climate Action",
        blurb: "",
        url: "https://www.indigenousclimateaction.com",
      },
      {
        title: "Quantifying national responsibility for climate breakdown...",
        publication: "The Lancet",
        blurb: "",
        url: "https://www.thelancet.com/journals/lanplh/article/PIIS2542-5196(20)30196-0/fulltext",
      },
      {
        title:
          "&quot;Colonizing the Atmosphere&quot;: How Rich, Western Nations Drive the Climate Crisis",
        publication: "In These Times",
        author: "Sarah Lazare",
        blurb: "",
        url: "https://inthesetimes.com/article/climate-change-wealthy-western-nations-global-north-south-fires-west",
      },
    ],
    transcript: `<p>There can be no environmental justice without social justice.</p>
<p> Climate justice begins with recognising key groups are differently affected by climate change. Often, those who contributed least to causing it will experience the worst impacts.
</p>
<p> The impacts of climate change will not be borne equally or fairly, between rich and poor, women and men, and older and younger generations.
</p>
<p> Generally, many victims of climate change also have disproportionately low responsibility for causing the emissions responsible for climate change in the first place– particularly youth or people of any age living in developing countries that produce fewer emissions per capita than is the case inthe major polluting countries.
</p>
<p> Climate impacts can exacerbate inequitable social conditions. Low - income communities, people of color, indigenous people, people with disabilities, older or very young people, women and gender non - conforming people– all can be more susceptible to risks posed by climate impacts like raging storms and floods, increasing wildfire, severe heat, poor air quality, access to food and water,and disappearing shorelines.
</p>
<ul> <li>Communities of color are often more at risk from air pollution</li> <li> Seniors, people with disabilities, and people with chronic illnesses may have a harder time living through periods of severe heat, or being able to quickly and safely evacuate from major storms or fire. </li> <li> People with limited income may live in subsidized housing, which too often is located in a flood plain. Their housing options may also have inadequate insulation, mold problems, or air conditioning to effectively combat severe heat or cope with strong storms. Economically challenged people may also be hard - pressed to afford flood or fire insurance, rebuild homes, or pay for steep medical bills after catastrophe strikes. </li> <li> Language barriers can make it difficult for immigrant communities toget early information about incoming storms or weather disasters or wildfires, or to communicate effectively with first responders in the midst of an evacuation order. </li> <li> Some indigenous communities are already seeing their homes and livelihoods lost to rising sea levels or drought. </li> <li> Prolonged drought and flooding can affect food supply or distribution, making it harder for people to access affordable, healthy food. </li> <li> Today’ s youth and future generations will experience more profound impacts of climate change as it worsens over time, from direct adverse health impacts to the financial implications of needing to shore - up infrastructure and other adaptation and mitigation needs. </li>
</ul>
<p> Environmental and climate justice is a civil rights issue. We all depend on the physical environment and its bounty.
</p>
<p> We cannot focus on the climate crisis without acknowledging how it is connected to public lands and racism, rooted in colonialism, capitalism and oppression.
</p>
<p> Hi everyone, this is małgorzata stankiewicz here and you just heard me quote from a piece What is‘ climate justice’ ? by Daisy Simmons and the City of Vancouver Climate Emergency Action Plan Summary, as part of my public space installation, Lassen(This Is an Emergency), which explores urgent topics affecting Canada in the wake of the deepening climate crisis while questioning the impact and role of mass - media in portraying and shaping the discourse around the global environmental emergency, displayed on large - scale posters throughout Toronto’ s streets during Contact Photography Festival in June 2021 
</p>`,
  },
  {
    slug: "logging-scars-suppress-forest-regenaration",
    title: `Logging Scars Suppress Forest Regeneration`,
    audio: "/lassen/audio/logging_scars_suppress_forest_regeneration.mp3",
    img: "lassen-logging-scars.jpg",
    bg: "#f49331",
    fg: "#f9f3dd",
    blend: "#cd5029",
    mode: "normal",
    shadow: "#23191a",
    links: [
      {
        title: "THE LOGGING LOOPHOLE",
        publication: "Nature Canada",
        url: "https://naturecanada.ca/wp-content/uploads/2020/07/Boreal-Report-2020.pdf",
      },
      {
        title: "Aerial Images Show Widespread Deforestation in Ontario",
        url: "https://www.nrdc.org/experts/jennifer-skene/aerial-images-show-more-widespread-deforestation-ontario",
        author: "Jennifer Skene",
        publication: "NRDC",
      },
      {
        title:
          "Canada under-reporting deforestation and carbon impacts by forestry",
        url: "https://wildlandsleague.org/news/loggingscars/",
        author: "",
        publication: "Wildlands League",
      },
      {
        title:
          "‘Logging scars’ show impact of deforestation in Canada is worse than we know",
        url: "https://www.theglobeandmail.com/canada/article-logging-scars-show-impact-of-deforestation-in-canada-is-worse-than/",
        publication: "The Globe and Mail",
        author: "Ivan Semeniuk",
      },
      {
        title:
          "Long-term damage from logging hits ability of Canada's forests to regenerate",
        url: "https://www.theguardian.com/world/2019/dec/04/canada-logging-scars-forests-regenerate",
        publication: "The Guardian",
        author: "Leyland Cecco",
      },
      {
        title:
          "Scars from logging operations show Canadian deforestation far worse than previously thought",
        url: "https://thenarwhal.ca/scars-from-logging-operations-show-canadian-deforestation-far-worse-than-previously-thought/",
        author: "Sarah Cox",
        publication: "The Narwhal",
      },
    ],
    transcript: `<p> Roads, pits and other ‘logging scars’ have caused underreported environmental damage to forests, with hidden costs for Canada’s carbon footprint. Because the vestigial remains of roads, landings and turnoffs meant to accommodate heavy machinery are so heavily compacted, seedlings have little chance of successfully repopulating these areas.
</p>
<p> The Canadian boreal forest, which comprises a quarter of the world’ s remaining intact forest and and is part of the most carbon - dense forest biome on the planet, is particularly key to achieving a 1.5° C pathway.In its soils and vegetation, the Canadian boreal stores twice as much carbon as the world’ s oil reserves.It is central to global carbon regulation, making its protection and management a matter of global importance.Yet each year, industrial logging erodes the Canadian boreal’ s value for the climate, cutting down more than 400, 000 hectares of the forest to turn it into toilet paper, newsprint, lumber, and biofuels.To put this in perspective, Canada falls just behind Brazil and Russia in terms of annual intact forest landscape loss, even when losses caused by wildfires are removed— with 60 percent of this loss occurring in areas leased by logging companies.More than 90 percent of this logging is in the form of clear cutting, a practice in which the logging operation removes nearly all the trees from a given area
</p>
<p> Unfortunately, current carbon emissions estimates, while troubling, may not even tell the whole story. They likely downplay logging’s full climate impact because they assume complete forest recovery, in alignment with industry and provincial government claims that the forest grows back entirely after it has been cut (i.e., for every tree that is cut down, another tree regrows). Under this assumption, eventually the forest will regain the carbon sequestration capacity and biodiversity functions it had prior to being clearcut, and this, the logging industry claims, makes it inherently sustainable.And because the forest is not converted to another use, such as farmland or city development, Canada does not classify the logging that is occurring as“ deforestation, ”instead designating it as“ degradation.”
</p>
<p> However, in addition to the fact that, as discussed below, second-growth forests tend to lack the same ecosystem services and health of primary forests, a study of more than two dozen logged forest sites in northwestern Ontario found that more than 14 percent of the logged area was essentially barren 20 to 30 years after the logging occurred. Nor was there evidence from those sites that trees would become reforested by the time re-logging of the site is planned. These long- term scars are due to the creation of logging roads and “landings,” where logs and unwanted logging residue are processed with heavy equipment and stacked, compacting the earth and suppressing regrowth.80 While that research covered only one region of Ontario, the full-tree logging practice that led to this deforestation, in which the entire logged tree is dragged to the roadside, is the dominant approach in Ontario and accounts for about 50 percent of logging in Quebec. It is also used in British Columbia, Alberta, and the prairie provinces. Thus, it is likely that these scars exist in clearcuts throughout much of the Canadian boreal.
</p>
<p> As a result, while Canada claims that it has nearly zero deforestation— and proudly holds itself up in contrast to countries like Brazil and Indonesia— the truth is that a significant portion of forest is not regrowing.If the results from the 27 clearcuts studied are indicative of conditions across all of Ontario, uncounted logging infrastructure in this province alone would increase Canada’ s reported deforestation rate by 700 percent.
</p>
<p> Hi everyone, this is Małgorzata Stankiewicz here and you just heard me quote from THE LOGGING LOOPHOLE: HOW THE LOGGING INDUSTRY’S UNREGULATED CARBON EMISSIONS UNDERMINE CANADA’S CLIMATE GOALS by Nature Canada as part of my public space installation, Lassen (This Is an Emergency), which explores urgent topics affecting Canada in the wake of the deepening climate crisis while questioning the impact and role of mass-media in portraying and shaping the discourse around the global environmental emergency, displayed on large-scale posters throughout Toronto’s streets during Contact Photography Festival in June 2021.
</p>
`,
  },

  {
    slug: "reducing-human-emissions-will-reduce-future-climate-change",
    title: `Reducing Human Emissions Will Reduce Future Climate Change`,
    img: "lassen-reducing-human-emissions.jpg",
    audio:
      "/lassen/audio/reducing_human_emissions_will_reduce_future_climate_change.mp3",
    fg: "#fdeece",
    bg: "#620e0e",
    shadow: "#620e0e",
    blend: "#620e0e",
    mode: "normal",
    links: [
      {
        title: "Modelling Future Climate Change",
        author: "",
        publication: "Canada’s Changing Climate Report",
        url: "https://changingclimate.ca/CCCR2019/chapter/3-0/",
      },
      {
        title: "Global Warming of 1.5 ºC, Special Report",
        author: "",
        publication: "The Intergovernmental Panel on Climate Change",
        url: "https://www.ipcc.ch/sr15/",
      },
      {
        title: "Climate Action Fast Facts",
        author: "",
        publication: "United Nations",
        url: "https://www.un.org/en/climatechange/science/key-findings",
      },
      {
        title:
          "Underlying features of the Representative Concentration Pathways",
        author: "",
        publication: "Canada’s Changing Climate Report",
        url: "https://changingclimate.ca/CCCR2019/chapter/3-0/3-2/figure-3-1-3/",
      },
      {
        title: "Building an Earth system model",
        author: "",
        publication: "Canada’s Changing Climate Report",
        url: "https://changingclimate.ca/CCCR2019/chapter/3-0/3-2/figure-3-2-2/",
      },
      {
        title:
          "Observed global mean annual surface temperatures anomalies, 1850–2016",
        author: "",
        publication: "Canada’s Changing Climate Report",
        url: "https://changingclimate.ca/CCCR2019/chapter/2-0/2-2/2-2-1/figure-2-1/",
      },
      {
        title: "Global climate projections",
        author: "",
        publication: "Canada’s Changing Climate Report",
        url: "https://changingclimate.ca/CCCR2019/chapter/3-0/3-3/3-3-3/figure-3-6-4/",
      },
      {
        title:
          "Carbon dioxide concentrations and compatible emissions under the four Representative Concentration Pathways",
        author: "",
        publication: "Canada’s Changing Climate Report",
        url: "https://changingclimate.ca/CCCR2019/chapter/3-0/3-3/3-3-4/figure-3-7-2/",
      },
      {
        title:
          "Relationship between global temperature and cumulative carbon dioxide emissions",
        author: "",
        publication: "Canada’s Changing Climate Report",
        url: "https://changingclimate.ca/CCCR2019/chapter/3-0/3-2/figure-3-8/",
      },
      {
        title:
          "Persistent elevation of global temperature after cessation of emissions",
        author: "",
        publication: "Canada’s Changing Climate Report",
        url: "https://changingclimate.ca/site/assets/uploads/sites/2/2019/01/Figure-3.8.png",
      },
    ],
    transcript: `<p>Emissions of greenhouse gases from human activity, particularly carbon dioxide, will largely determine the magnitude of climate change over the next century. Therefore, reducing human emissions will reduce future climate change.
</p>

<p>In the near term(to approximately 2040), projected warming will be similar under all emission pathways.But by the late 21 st century, the differences between possible emission pathways will have a considerable effect.Available estimates indicate that the global climate will warm by an additional 1° C( for a low emission scenario) to 3.7° C( for a high emission scenario).Scenarios that would limit warming to an additional 1° C or less require rapid and deep emission reductions.
</p>

<p>To limit temperature increase, annual emissions in 2030 need to be 15 gigatonnes of CO2 equivalent lower than all current unconditional commitments under the Paris Agreement are implemented imply for the 2° C goal;they need to be 32 gigatonnes lower for the 1.5° C goal.On an annual basis, this means cuts in emissions of 7.6 per cent per year from 2020 to 2030 to meet the 1.5° C goal.
</p>

<p>Limiting warming to 1.5° C is not impossible but it would require unprecedented transitions in all aspects of society. Next 10 years are critical.Global net human - caused emissions of carbon dioxide(CO2) would need to fall by about 45 percent from 2010 levels by 2030, reaching‘ net zero’ around 2050.
</p>

<p>There are clear benefits to limiting warming to 1.5° C compared to 2° C: 420 million fewer people being exposed to severe heat waves, survival of some tropical coral reefs, loss of fewer plants and animal species, and the protection of forests and wetland habitats.
</p>

<p>The decisions we make now will define the world we live in and for future generations. Tackling climate change is critical to ensure that people around the world are healthy, prosperous, have food, clean air and water.
</p>

<p>Hi everyone, this is Małgorzata Stankiewicz here and you just heard me quote from the Canada’ s Changing Climate Report and the IPCC special report on the impacts of global warming of 1.5° C above pre - industrial levels and related global greenhouse gas emission pathways as part of my public space installation, <em> Lassen(This Is an Emergency) </em>, which explores urgent topics affecting Canada in the wake of the deepening climate crisis while questioning the impact and role of mass-media in portraying and shaping the discourse around the global environmental emergency. The works will be displayed on large-scale posters throughout the streets of Toronto during Contact Photography Festival in June 2021.
</p>
`,
  },
  {
    slug: "the-seasonal-availability-of-freshwater-is-changing",
    title: `The Seasonal Availability of Freshwater Is Changing`,
    img: "lassen-seasonal-availability-of-freshwater.jpg",
    audio:
      "/lassen/audio/the_seasonal_availability_of_freshwater_is_changing.mp3",
    bg: "#7c516d",
    fg: "#eeb8dd",
    shadow: "#1b0c13",
    noglow: true,
    blend: "#1b0c13",
    mode: "normal",
    links: [
      {
        title: "Chapter 6:Changes in Freshwater Availability Across Canada",
        author: "",
        publication: "Canada’s Changing Climate Report",
        url: "https://changingclimate.ca/CCCR2019/chapter/6-0/",
      },
      {
        title:
          "The water cycle, its components, relevant processes, and interactions",
        author: "",
        publication: "Canada’s Changing Climate Report",
        url: "https://changingclimate.ca/CCCR2019/chapter/6-0/6-1/figure-6-1-2/",
      },
      {
        title: "Groundwater storage trends in Alberta, 2002–2014",
        author: "",
        publication: "Canada’s Changing Climate Report",
        url: "https://changingclimate.ca/CCCR2019/box/box-6-3/figure-6-17/",
      },
      {
        title:
          "Changes in mean annual Standardized Precipitation Evapotranspiration Index for western Canadian watersheds",
        author: "",
        publication: "Canada’s Changing Climate Report",
        url: "https://changingclimate.ca/CCCR2019/chapter/6-0/6-4/6-4-2/figure-6-15/",
      },
    ],
    transcript: `<p>The Seasonal Availability of Freshwater Is Changing</p>
<p> Freshwater availability in Canada is influenced by a multitude of factors: some natural, some as a result of human activity. Changes in precipitation and temperature have a strong influence, both directly and indirectly, through changes to snow, ice, and permafrost. Disturbances of the water cycle by humans(dams, diversions, and withdrawals) make it difficult to discern climate - related changes.
</p>
<p> It is expected that a changing climate will impact several of the factors affecting future streamflow flood occurrence. These include precipitation amount, type, and intensity;the amount and duration of snow cover;the timing and frequency of ice jams;and the potential for rain - on - snow events.
</p>
<p> These anticipated changes from anthropogenic climate warming will directly affect the timing and amount of future freshwater supplies, and they may be exacerbated by human management alterations to freshwater systems. The impacts are expected to be more prominent toward the end of this century under higher emission scenarios, given the larger associated climate changes. Of particular concern are impacts in regions that currently rely on snow and ice melt as freshwater sources, as well as continental interior areas, where increased evapotranspiration from warmer temperatures could reduce future water supplies.However, freshwater supplies in all regions of Canada are expected to be affected in one way or another.It is also anticipated that water - related extremes, such as droughts and floods, will intensify these impacts.
</p>
<p> Hi everyone, this is Małgorzata Stankiewicz here and you just heard me quote from the Canada’ s Changing Climate Report as part of my public space installation, <em> Lassen(This Is an Emergency) </em>, which explores urgent topics affecting Canada in the wake of the deepening climate crisis while questioning the impact and role of mass-media in portraying and shaping the discourse around the global environmental emergency. The works are displayed on large-scale posters throughout the streets of Toronto during Contact Photography Festival in June 2021.
</p>
`,
  },

  //-------

  {
    title: "The Public Needs to Know That This Land Is Being Degraded",
    link: "https://thenarwhal.ca/report-buried-by-alberta-government-reveals-mounting-evidence-that-oil-and-gas-wells-arent-reclaimed-in-the-long-run/",
    img: "the-arctic-is-on-fire.jpeg",
    slug: "the-public-needs-to-know-that-this-land-is-being-degraded",
    bg: "#430000",
    fg: "#c72920",
    shadow: "#eadba4",
    noglow: 1,
  },
  // {
  //     title: "Violence Against the Earth Begets Violence Against Women",
  //     img: "violence-against-the-earth-begets-violence-against-women.jpeg",
  //     slug: "violence-against-the-land-begets-violence-against-women",
  //     bg: "#000000",
  //     fg: "#ffffff",
  //     shadow: "#000000"
  // },
  {
    title:
      "All New Projects That Enable Fossil Fuel Growth Are an Affront to Our State of Climate Emergency",
    link: "https://www.theguardian.com/commentisfree/2020/feb/21/nobel-prize-winners-justin-trudeau-teck-frontier-mine",
    img: "all-new-projects-enable-fossil-fuel-growth-are-an-affront-to-climate-emergency.jpeg",
    slug: "all-new-projects-enable-fossil-fuel-growth-are-an-affront-to-climate-emergency",
    bg: "#eadba4",
    fg: "#ffffff",
    shadow: "#eadba4",
  },
  {
    title: "Oil & Gas Firms Have Had Far Worse Climate Impact Than Thought",
    img: "oil-and-gas-firms-have-had-far-worse-climate-impact-than-thought.jpeg",
    slug: "oil-and-gas-firms-have-had-far-worse-climate-impact-than-thought",
    fg: "#fcb859",
    bg: "#eb5816",
    shadow: "#531008",
    link: "https://www.theguardian.com/environment/2020/feb/19/oil-gas-industry-far-worse-climate-impact-than-thought-fossil-fuels-methane",
  },
  {
    title:
      "Indigenous Canadians Face a Crisis as Climate Change Eats Away Island Home",
    img: "indigenous-canadians-face-a-crisis.jpeg",
    slug: "indigenous-canadians-face-a-crisis",
    link: "https://www.theguardian.com/world/2017/jan/18/canada-island-climate-change-sea-level-rise-lennox",
    bg: "#43527b",
    fg: "#d6ddeb",
    shadow: "#43527b",
  },
  // {
  //     title: "We Have a Biodiversity Crisis",
  //     img: "we-have-a-bio-diversity-crisis.jpeg",
  //     slug: "we-have-a-bio-diversity-crisis",
  //     link: "https://thenarwhal.ca/biodiversity-crisis-feds-announce-175-million-new-conservation-projects/",
  //     bg: "#000000",
  //     fg: "#ffffff",
  //     shadow: "#000000"
  // },
  {
    title:
      "These Old-Growth Forests Are Not Renewable, They’re Not Coming Back After You Log Them",
    img: "these-old-growth-forests-are-not-renewable.jpeg",
    slug: "these-old-growth-forests-are-not-renewable",
    link: "https://thenarwhal.ca/canadas-forgotten-rainforest/",
    bg: "#000000",
    fg: "#adaef0",
    shadow: "#000000",
  },
  {
    title: "Arctic Permafrost Thawing 70 Years Sooner Than Predicted",
    img: "arctic-permafrost-thawing-70-years-sooner.jpeg",
    slug: "arctic-permafrost-thawing-70-years-sooner",
    link: "https://www.theguardian.com/environment/2019/jun/18/arctic-permafrost-canada-science-climate-crisis",
    bg: "#ffe6b8",
    fg: "#ffffff",
    shadow: "#b29671",
  },
  {
    title: "This Year’s Flooding Is Very Extreme",
    img: "this-years-flooding-is-very-extreme.jpeg",
    slug: "this-years-flooding-is-very-extreme",
    link: "https://www.theguardian.com/world/2019/apr/30/canada-flooding-quebec-montreal-justin-trudeau-climate-change",
    bg: "#2a418f",
    fg: "#bfddf5",
    shadow: "#1d243a",
  },
  // {
  //     title: "Logging Scars Suppress Forest Regeneration",
  //     img: "logging-scars-suppress-forest-regeneration.jpeg",
  //     slug: "logging-scars-suppress-forest-regeneration",
  //     link: "https://www.theglobeandmail.com/canada/article-logging-scars-show-impact-of-deforestation-in-canada-is-worse-than/",
  //     bg: "#000000",
  //     fg: "#ffffff",
  //     shadow: "#000000"
  // },
  // {
  //     title: "Anthropogenic Climate Change Has Increased the Likelihood of Some Type of Extreme Events Such as the 2016 Fort McMurray Wildfire",
  //     img: "antrhopogenic-climate-change.jpeg",
  //     slug: "antrhopogenic-climate-change",
  //     link: "https://changingclimate.ca/CCCR2019/chapter/4-0/4-4/",
  //     bg: "#000000",
  //     fg: "#ffffff",
  //     shadow: "#000000",
  // },
  {
    title: "Fracking Boom Tied to Methane Spike in Earth’s Atmosphere",
    img: "fracking-boom-tied-to-methane-spikes.jpeg",
    slug: "fracking-boom-tied-to-methane-spikes",
    link: "https://www.nationalgeographic.com/environment/2019/08/fracking-boom-tied-to-methane-spike-in-earths-atmosphere/",
    bg: "#a75c01",
    fg: "#f7cb8c",
    shadow: "#a75c01",
  },
  {
    title: "Out in the Great Lakes, an Alarm is Sounding",
    img: "out-in-the-great-lakes-an-alarm-is-sounding.jpeg",
    slug: "out-in-the-great-lakes-an-alarm-is-sounding",
    link: "https://thenarwhal.ca/out-in-the-great-lakes-an-alarm-is-sounding/",
    bg: "#e5cc9e",
    fg: "#f9f9f9",
    shadow: "#e5cc9e",
    mode: "normal",
  },
  {
    title: "It Is Clear That the Earth Is on an Unsustainable Trajectory",
    img: "it-is-clear-that-the-earth-is-on-an-unsustainable-trajectory.jpeg",
    slug: "it-is-clear-that-the-earth-is-on-an-unsustainable-trajectory",
    link: "https://www.theguardian.com/environment/2020/feb/21/jp-morgan-economists-warn-climate-crisis-threat-human-race",
    bg: "#9f81ac",
    fg: "#e4c5d6",
    shadow: "#9f81ac",
  },
  {
    title:
      "Climate Change Poses a Major Threat to Sensitive Species Like the American Pika",
    img: "climate-change-poses-a-major-threat-to-sensitive-species.jpeg",
    slug: "climate-change-poses-a-major-threat-to-sensitive-species",
    link: "https://blog.nwf.org/2019/02/the-pika-predicament-wildlife-the-climate-crisis/",
    bg: "#c9af8e",
    fg: "#fedcb1",
    shadow: "#c9af8e",
  },
  {
    title:
      "Future Changes in Human Emissions of CO2 Will Largely Determine Future Climate",
    img: "future-changes-in-human-emissions-will-largely-determine-future-climate.jpeg",
    slug: "future-changes-in-human-emissions-will-largely-determine-future-climate",
    link: "https://changingclimate.ca/CCCR2019/chapter/8-0/",
    bg: "#817072",
    fg: "#cab8b5",
    shadow: "#817072",
  },
  {
    title:
      "Until the Climate Is Stabilized, There Will Not Be a New ‘Normal’ Climate",
    img: "until-the-climate-is-stabilized-there-will-not-be-a-new-normal-climate.jpeg",
    slug: "until-the-climate-is-stabilized-there-will-not-be-a-new-normal-climate",
    link: "https://changingclimate.ca/CCCR2019/chapter/8-0/",
    bg: "#3d3d58",
    fg: "#fff9f3",
    shadow: "#3d3d58",
    mode: "normal",
  },
  // {
  //     title: "The Seasonal Availability of Freshwater Is Changing",
  //     img: "the-seasonal-timing-of-extreme-flow-has-shifted.jpeg",
  //     slug: "the-seasonal-timing-of-extreme-flow-has-shifted",
  //     link: "https://changingclimate.ca/CCCR2019/chapter/6-0/",
  //     bg: "#000000",
  //     fg: "#ffffff",
  //     shadow: "#000000",
  // },
  {
    title:
      "Canada And the World Face Very Different Futures, Depending on the Level And Speed at Which Measures to Reduce Greenhouse Gas Emissions Are Implemented",
    img: "canada-and-the-world-face-very-diffrent-futures.jpeg",
    slug: "canada-and-the-world-face-very-diffrent-futures",
    bg: "#94a69a",
    fg: "#f1f3d6",
    shadow: "#2b6d89",
    mode: "normal",
    link: "https://changingclimate.ca/CCCR2019/chapter/8-0/8-2/",
  },
  {
    title: "The Arctic Is on Fire",
    img: "the-arctic-is-on-fire.jpeg",
    slug: "the-arctic-is-on-fire",
    link: "https://www.newscientist.com/article/2211013-hugearcticfires-have-now-emitted-a-record-breaking-amount-of-co2/",
    bg: "#430000",
    fg: "#9b4140",
    shadow: "#430000",
    mode: "normal",
  },
  // {
  //     title: "Why Is Canada Warming Faster Than the World As a Whole?",
  //     img: "why-is-canada-warming-faster.jpeg",
  //     slug: "why-is-canada-warming-faster",
  //     link: "https://changingclimate.ca/CCCR2019/chapter/4-0/4-2/",
  //     bg: "#000000",
  //     fg: "#ffffff",
  //     shadow: "#000000",
  // },
  {
    title: "The Seasonal Timing of Peak Streamflow Has Shifted",
    img: "the-seasonal-timing-of-extreme-flow-has-shifted.jpeg",
    slug: "the-seasonal-timing-of-extreme-flow-has-shifted",
    link: "https://changingclimate.ca/CCCR2019/chapter/6-0/6-2/",
    bg: "#924358",
    fg: "#f7d9ed",
    shadow: "#924358",
    mode: "normal",
  },
  // {
  //     title: "Reducing Human Emissions Will Reduce Future Climate Change",
  //     img: "reducing-human-emissions.jpeg",
  //     slug: "reducing-human-emissions-x",
  //     link: "https://changingclimate.ca/CCCR2019/chapter/3-0/3-2/",
  //     bg: "#000000",
  //     fg: "#ffffff",
  //     shadow: "#000000",
  // },
  {
    title:
      "*In the Alpine and Tundra Areas of Kluane, Trees And Woody Shrubs Are Taking Over the Lichen, Sedge And Grasslands of the Tundra",
    img: "in-the-alpine-tundra-areas-of-kluane.jpeg",
    slug: "in-the-alpine-tundra-areas-of-kluane",
    link: "https://e360.yale.edu/features/how-warming-is-profoundly-changing-a-great-northern-wilderness",
    bg: "#9c7fd",
    fg: "#ecd0ac",
    shadow: "#9c7f6d",
    mode: "normal",
  },
];